import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router';
import pathToRegexp from 'path-to-regexp';
import {
  selectCategory,
  selectSubcategory,
  loading,
  unsetMenu,
} from './views/menu/actions';
import { logoutUser, removeUser } from './redux/actions/authenticationActions';
import MediaQuery from 'react-responsive';
import { dashboardData } from './views/dashboard/reducer';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import {
  getCartPriceDetails,
  setCheckout,
  parsePrice,
  cookieValue,
} from './lib/helper.js';
import { Memoize } from './socket/memoize';
import {
  updateOrderIdDetails,
  showMobileSidebar,
  locationChanged,
} from './views/dashboard/actions';
import { browserHistory } from 'react-router';
import { get, forEach, orderBy, isEmpty } from 'lodash';
import RightNavigation from './views/menu/components/RightNavigation';
import './public/css/Dashboard.css';
import defaultMsg from '../src/translations/lang/en-US.json';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mainCategoryId: 0,
      subCategoryId: 0,
      showMore: false,
      showCaterogyMoreIcon: false,
      intSubnavHeight: 0,
      link: '/' + this.props.rname,
      subCategoryClicked: false,
      page: this.getActivePage(),
    };

    this.selectSubcategory = this.selectSubcategory.bind(this);
    this.selectCategory = this.selectCategory.bind(this);
    this.showSigninModal = this.showSigninModal.bind(this);
    this.handleSidebar = this.handleSidebar.bind(this);
    this.handleOrderPanel = this.handleOrderPanel.bind(this);
    this.getMenuItem = this.getMenuItem.bind(this);
    this.adjustLogoFontSize = this.adjustLogoFontSize.bind(this);
    this.getActivePage = this.getActivePage.bind(this);
  }

  getActivePage(activePage = this.props.location.pathname) {
    const filteredUrl = activePage.replace(/^\/|\/$/g, '').split('/');
    return filteredUrl.length === 1 ? 'dashboard' : filteredUrl[1];
  }

  componentDidMount() {
    this.adjustLogoFontSize();
    const authData = get(
      this,
      'props.authData.loginUserDetails.guestUser',
      null
    );
    let cookieData = cookieValue('token');
    if (cookieData === null && authData === null) {
      this.props.dispatch(removeUser());
    }
    window.addEventListener('resize', this.adjustLogoFontSize);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      page: this.getActivePage(nextProps.location.pathname),
    });
  }

  adjustLogoFontSize() {
    if (this.refs.restaurantLogo) {
      const imgObject = new Image();
      imgObject.src = this.refs.restaurantLogo.src;
      imgObject.onload = () => {
        const logoContainer = this.refs.logoContainer;
        const isOverflown = element => {
          return (
            element.scrollHeight > element.clientHeight ||
            element.scrollWidth > element.clientWidth
          );
        };
        const logoTextRef = this.refs.restaurantName;
        const logoTextFontSize = element => {
          return parseFloat(
            window.getComputedStyle(element, null).getPropertyValue('font-size')
          );
        };
        if (logoTextRef) {
          const size = logoTextFontSize(logoTextRef);
          logoTextRef.style.display = 'inline';

          if (isOverflown(logoContainer) && size > 12) {
            logoTextRef.style.fontSize = size - 1 + 'px';
            this.adjustLogoFontSize();
          } else if (isOverflown(logoContainer)) {
            logoTextRef.style.fontSize = size + 2 + 'px';
            logoTextRef.style.display = 'none';
          }
        }
      };
    }
  }

  handleCheckout() {
    if (window.innerWidth > 768) {
      if (this.props.authenticated || this.props.guest) {
        setCheckout(
          this,
          true,
          function(response) {
            this.props.dispatch(updateOrderIdDetails(response));
            this.props.dispatch(unsetMenu());
            browserHistory.push('/' + this.props.rname + '/checkout');
          }.bind(this)
        );
      } else {
        this.showSigninModal();
      }
    } else {
      this.props.dispatch(showMobileSidebar());
      browserHistory.push('/' + this.props.rname);
    }
  }

  renderMainCategoryLinks() {
    const menuCategories = get(this, 'props.menuCategories.menu_category', []);
    const renderElement = menuCategories.map((category, index) => {
      if (category.parentid === '-1') {
        const link = '/' + this.props.rname;
        const activeStyle =
          category.id === this.props.mainMenuItemClicked &&
          this.state.page === 'dashboard'
            ? 'active mainnav-active'
            : '';
        if (activeStyle) {
          document.title = `${category.text} - ${
            this.props.restaurantName
          } - Lavu To Go`;
        }
        return (
          <li
            ref={`${index}liMainCat`}
            id={'main' + category.id}
            className="liMainCat"
            key={`${index}header`}
            onClick={() => {
              this.selectCategory(category.id);
            }}
          >
            <Link activeClassName={activeStyle} to={link}>
              {category.text}
            </Link>
          </li>
        );
      } else {
        return null;
      }
    }, this);

    return [renderElement];
  }

  renderSubCategoryLinks() {
    const arr = [];
    const subMenuArr = [];
    var sortedMenu = [];
    forEach(
      get(this, 'props.menuCategories.menu_category', {}),
      function(subCategory, index) {
        if (subCategory.parentid === this.props.mainMenuItemClicked) {
          subMenuArr.push({
            index: index,
            id: subCategory.id,
            text: subCategory.text,
            _order: subCategory._order,
          });
        }
      }.bind(this)
    );
    sortedMenu =
      this.props.mainMenuOrderBy === 'alpha' ||
      this.props.mainMenuOrderBy === '' ||
      this.props.mainMenuOrderBy === 0
        ? orderBy(subMenuArr, 'text', 'asc')
        : subMenuArr.sort((a, b) => {
            return a._order - b._order;
          });
    forEach(
      sortedMenu,
      function(subCategory, index) {
        arr.push(
          this.getMenuItem({
            index: index,
            id: subCategory.id,
            text: subCategory.text,
          })
        );
      }.bind(this)
    );
    forEach(
      get(this, 'props.menuCategories.universal_category', []),
      function(universalCategory, key) {
        arr.push(
          this.getMenuItem({
            index: `${key}-universal-`,
            id: universalCategory.id,
            text: universalCategory.name,
          })
        );
      }.bind(this)
    );
    return arr;
  }

  getMenuItem({ index, id, text }) {
    const isActive =
      id === this.props.subMenuItemClicked && this.state.page === 'dashboard';
    let subMenuId = 'subMenu_' + id;
    return (
      <li
        className="liSubCat"
        key={`${index}-subheader`}
        onClick={() => {
          this.selectSubcategory(id, text);
        }}
        id={subMenuId}
      >
        <Link
          activeClassName={isActive ? 'active subnav-active' : ''}
          to={`/${this.props.rname}`}
        >
          {text}
        </Link>
      </li>
    );
  }

  renderSubCategoryMoreLinks() {
    let self = this;
    let arr = [];
    let el = document.getElementById('subCategory');
    let visibleTop = el.firstChild.getBoundingClientRect().top;
    forEach(this.props.menuCategories, function(subCategory, index) {
      let currentEl = document.getElementById(subCategory.id);
      let visible =
        currentEl && currentEl.getBoundingClientRect().top - visibleTop < 5;

      if (subCategory.parentid === self.props.mainMenuItemClicked) {
        var activeStyle = '';
        var link = '/' + self.props.rname;
        if (index === 0) {
          if (subCategory.id === self.props.subMenuItemClicked) {
            activeStyle = 'active subnav-active';
          }
          arr.push(
            <li
              style={{ display: visible ? 'none' : 'inline-block' }}
              className="liSubCat"
              key={`${index}subheader`}
              id={subCategory.id + 'more'}
              onClick={self.selectSubcategory(subCategory.id, subCategory.text)}
            >
              <Link activeClassName={activeStyle} to={link}>
                {subCategory.text}
              </Link>
            </li>
          );
        } else {
          if (subCategory.id === self.props.subMenuItemClicked) {
            activeStyle = 'active subnav-active';
          }
          arr.push(
            <li
              style={{ display: visible ? 'none' : 'inline-block' }}
              className="liSubCat"
              key={`${index}subheader`}
              id={subCategory.id + 'more'}
              onClick={() => {
                self.selectSubcategory(subCategory.id, subCategory.text);
              }}
            >
              <Link activeClassName={activeStyle} to={link}>
                {subCategory.text}
              </Link>
            </li>
          );
        }
      }
    });
    return arr;
  }

  selectCategory(id) {
    this.setState({
      mainCategoryId: id,
    });
    this.props.dispatch(selectCategory(id)).then(res => {
      this.selectSubcategory(
        this.props.subMenuItemClicked,
        this.props.bannerTxt
      );
    });

    this.setState({
      showMore: false,
    });
  }

  selectSubcategory(id, text) {
    let contentTop;
    let contentPaddingTop;
    if (document.getElementById('content') !== null) {
      contentTop = parseInt(
        window.getComputedStyle(document.getElementById('content')).top,
        0
      );
      contentPaddingTop = parseInt(
        window.getComputedStyle(document.getElementById('content')).paddingTop,
        0
      );
    }

    this.setState({
      subCategoryId: id,
    });
    this.props.dispatch(loading(true));
    Memoize.reset('menu_items');
    this.props
      .dispatch(
        selectSubcategory(
          id,
          text,
          this.props.dashboardData.modeOfOrder,
          this.props.tokenId,
          this.props.jwt,
          this.props.dashboardData.dataName
        )
      )
      .then(res => {
        if (document.getElementById('content') !== null) {
          if (
            window.getComputedStyle(document.getElementById('content')).top ===
            'auto'
          ) {
            document.getElementById('content').style.paddingTop =
              contentPaddingTop + 'px';
          } else {
            document.getElementById('content').style.top = contentTop + 'px';
          }
        }
        this.props.dispatch(loading(false));
      });
  }

  showSigninModal() {
    this.props.showSigninModalCallback('header');
  }

  handleSidebar() {
    this.props.viewSidebarCallback();
  }

  handleOrderPanel() {
    this.props.viewMobileOrderPanel();
  }

  logoutUser() {
    this.props.dispatch(
      locationChanged({
        changedDataName: null,
        status: false,
        resetUserLocation: true,
      })
    );

    this.props.dispatch(logoutUser('removeuser')).then(res => {
      window.location.reload();
    });
  }

  showMore() {
    this.setState({
      showMore: !this.state.showMore,
      intSubnavHeight: this.refs.subHeader.clientHeight,
    });
  }

  showMoreMain() {
    this.setState({
      intSubnavHeight: this.refs.mainHeader.clientHeight,
    });
  }

  render() {
    let myaccountSignInLink = null;
    const activeClass = 'active mainnav-active';
    let cookieData = cookieValue('token');
    if (!isEmpty(cookieData)) {
      myaccountSignInLink = (
        <ul>
          <li className="no-selection">
            <Link
              activeClassName={
                this.state.page === 'order-history' ? activeClass : ''
              }
              to={this.state.link + '/order-history'}
            >
              <FormattedMessage
                id="orderHistory"
                defaultMessage={defaultMsg.orderHistory}
              />
            </Link>
          </li>
          <li className="no-selection">
            <Link
              activeClassName={
                this.state.page === 'myaccount' ? activeClass : ''
              }
              to={this.state.link + '/myaccount'}
            >
              <FormattedMessage
                id="myAccount"
                defaultMessage={defaultMsg.myAccount}
              />
            </Link>
          </li>
          <li
            className="no-selection"
            onClick={() => {
              this.logoutUser();
            }}
          >
            <Link to={this.state.link}>
              <FormattedMessage
                id="signout"
                defaultMessage={defaultMsg.signout}
              />{' '}
              <b>({this.props.loginUserDetails.firstName})</b>
            </Link>
          </li>
        </ul>
      );
    } else {
      myaccountSignInLink = (
        <ul>
          <li
            className="subMenuItem no-selection"
            onClick={() => {
              this.showSigninModal();
            }}
          >
            <Link to="">
              <FormattedMessage
                id="signIn"
                defaultMessage={defaultMsg.signIn}
              />
            </Link>
          </li>
          <li className="no-selection">
            <Link to="">
              <FormattedMessage id="hello" defaultMessage={defaultMsg.hello} />{' '}
              {this.props.name}
            </Link>
          </li>
        </ul>
      );
    }
    const getMenuLogo = device => (
      <Link
        className={`navbar-brand ${
          device === 'mobile' ? 'mobile-logo' : 'web-navabar-brand'
        }`}
        to={this.state.link}
        onClick={this.forceUpdate}
      >
        <img
          className="navbar-logo"
          src={this.props.restaurantLogo}
          alt={this.props.restaurantName}
          ref="restaurantLogo"
        />
        <span ref="restaurantName" className="restaurant-name">
          {this.props.restaurantName}
        </span>
      </Link>
    );
    const cart = (
      <ul>
        <li
          id="cartImage "
          className="cursonPointer"
          onClick={this.handleCheckout.bind(this)}
        >
          <Link>
            <span className="glyphicon glyphicon-shopping-cart" />
            <span className="cart-total-price far-left">
              {Number(this.props.numberOfItemsInCart)}
            </span>
          </Link>
        </li>
        <li
          id="cartTotal"
          className="cursonPointer"
          onClick={this.handleCheckout.bind(this)}
        >
          <Link>
            <span className="cart-total-price">
              {parsePrice(
                getCartPriceDetails(
                  this.props,
                  this.props.paymode === 'paypal' ? true : 'false'
                )['grandTotal']
              )}
            </span>
          </Link>
        </li>
      </ul>
    );

    const excludeURLS = ['/:id/myaccount', '/:id/order-history'];
    let hideMenuItems = excludeURLS.reduce(
      (match, url) =>
        match ||
        pathToRegexp(url, [], {
          end: false,
        }).test(this.props.location.pathname),
      false
    );
    return (
      <div className="navbar-container">
        <nav
          id="mainHeader"
          ref="mainHeader"
          className="navbar navbar-default mainnav"
        >
          <div
            ref="logoContainer"
            className="navbar-header col-lg-3 col-sm-3 col-md-3 col-xs-8 xs-underlined"
          >
            <MediaQuery query="(min-device-width: 769px)">
              {getMenuLogo()}
            </MediaQuery>
            <MediaQuery query="(max-device-width: 768px)">
              {getMenuLogo('mobile')}
            </MediaQuery>
          </div>

          <div className="navbar-header olo-client-theme-color hidden-lg hidden-sm hidden-md col-xs-4 sub-menu make-left text-right xs-underlined">
            {cart}
          </div>

          <div className="hidden-xs navbar-header col-lg-5 col-md-5 col-xs-10 col-sm-5 menu-container main-category-links">
            {!hideMenuItems && (
              <ul ref="mainCategory" id="mainCategory">
                {this.renderMainCategoryLinks()}
              </ul>
            )}
          </div>
          <div className="hidden-xs navbar-header col-lg-4 col-md-4 col-sm-4 custom-menu-container">
            {myaccountSignInLink}
          </div>
        </nav>

        <nav className="navbar navbar-default d-flex d-align-items-center hidden-sm hidden-md hidden-lg">
          <div className="menu-container col-xs-10 px-0 pl-2">
            {!hideMenuItems && (
              <ul ref="mainCategory" id="mainCategory">
                {this.renderMainCategoryLinks()}
              </ul>
            )}
          </div>
          <div className="col-xs-2 custom-menu-container">
            <RightNavigation
              signIn={this.showSigninModal}
              signOut={this.logoutUser}
              link={this.state.link}
              page={this.state.page}
              menu={false}
            />
          </div>
        </nav>

        <nav
          id="subHeader"
          ref="subHeader"
          className="navbar navbar-default subnav olo-client-theme-background olo-client-theme-border"
        >
          <div
            className="col-lg-9 col-md-9 col-xs-12 col-sm-9 sub-menu xs-text-right"
            ref="subMenuContainer"
          >
            {!hideMenuItems && (
              <ul id="subCategory">{this.renderSubCategoryLinks()}</ul>
            )}
          </div>
          <div className="navbar-header col-lg-3 col-md-3 hidden-xs col-sm-3 sub-menu">
            {cart}
          </div>
        </nav>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    authenticated: state.auth.authenticated,
    authData: state.auth,
    menuCategories: state.menuCategories.menuCategories,
    menuItems: state.menuCategories.menuItems,
    mainMenuItemClicked: state.menuCategories.mainMenuItemClicked,
    subMenuItemClicked: state.menuCategories.subMenuItemClicked,
    mainMenuOrderBy: state.menuCategories.mainMenuOrderBy,
    restaurantName: state.dashboard.merchantDetails.title,
    restaurantLogo: state.dashboard.merchantDetails.logo_img,
    bannerTxt: state.menuCategories.bannerTxt,
    guest: state.auth.guest,
    name: state.auth.name,
    loginUserDetails: state.auth.loginUserDetails,
    dashboardData: dashboardData(state),
    tokenId: state.auth.tokenId,
    jwt: state.auth.jwt,
    paymode: state.dashboard.paymode,
    discount: state.checkout.discount,
    menuArray: state.menuCategories.menuArray,
  };
}

Header.propTypes = {
  intl: intlShape.isRequired,
};

export default withRouter(connect(mapStateToProps)(injectIntl(Header)));



// WEBPACK FOOTER //
// ./src/Header.js